export enum InsuranceType {
  IARD = 'IARD',
  LIFE = 'LIFE',

}
